import { SetStateAction } from "react";
import { UNKNOWN_ERROR } from "../constants";
import { isErrorEvent } from "./is-error-event";
import { isErrorInfo } from "./is-error-info";

export const processError = (
  error: unknown,
  setError: (value: SetStateAction<string>) => void
) => {
  const errorData = isErrorEvent(error) ? error.error : error;
  let errorText;

  if (isErrorInfo(errorData)) {
    errorText = errorData.message;
  } else if (typeof error === "string") {
    errorText = error;
  } else {
    errorText = UNKNOWN_ERROR;
  }

  setError?.(errorText);
};
